import React, { useState, useRef, useEffect } from 'react';
import dynamic from 'next/dynamic';
import {
  DesktopHeader,
  HeaderComponent,
  HeaderInner,
  HeaderSections,
  MobileHeader,
  MenuItem,
  StoreName,
  MobileDropownContainer,
  MobileHeaderDrawer,
  HeaderDrawerInner,
  HeaderSection,
  HeaderExpandable,
  HeaderIcon,
  HeaderExpandedList,
  HeaderSectionList,
  HeaderSectionListItem,
  HeaderExpandedListItem,
  DesktopHeaderDropdown,
  DesktopDropdownItemList,
  DesktopDropdownItem,
  CartTotalContainer,
  ShopingIconWrap,
} from './index.styles';
import { Arrow } from '@/assets/svgExports/Arrow';
import { HeaderArrow } from '@/assets/svgExports/HeaderArrow';
import { HeaderHome } from '@/assets/svgExports/HeaderHome';
import { InfoIcon } from '@/assets/svgExports/InfoIcon';
import { OrderIcon } from '@/assets/svgExports/OrderIcon';
import { SearchIcon } from '@/assets/svgExports/SearchIcon';
import { SupermarketIcon } from '@/assets/svgExports/SupermarketIcon';
import { UserIconDark } from '@/assets/svgExports/UserIconDark';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getRoute, PATH } from '@/utils/routes';
import { isPLPRequiredSystem } from '@/utils/isPLPRequiredSystem';
import { commonToggleAuthModal } from '@/utils/commonToggleAuthModal';
import { deviceWidth } from '@/utils/deviceWidth';
import { getStoreType } from '@/utils/getStoreType';
import { removeEmoticons } from '@/utils/emoticonsStatus';
import getOrdersDropdownList from '@/utils/orderDropdownList';
import { commonOutsideClick } from '@/utils/isClickOutside';
import { ORDERS_DROPDOWN_LIST, STORE_CUSTOMIZATION } from '@/utils/constants';
import { executeLogout } from '@/utils/excuteLogout';
import getCustomCtaText from '@/utils/getCustomCtaText';
import useSaveHeaderHeight from '@/hooks/useSaveHeaderHeight';
import { useFeatureLocks } from '@/hooks/useFeatureLocks';
import { toggleRfqFormModal } from '@/redux/actions';
import { useSSRSelector } from '@/redux/ssrStore';
import { showMegaMenu } from '@/utils/showMegaMenu';
import { getVisibilityForHeader } from '@/utils/logoAndNameHelpers';
import { redirectToHomePage } from '@/utils/handleRedirectToHomePage';
import getActualOrDsStoreLogo from '@/utils/getActualOrDsStoreLogo';
import { showMyAccount } from '@/utils/getNavList';
import WishlistHeaderMenuItem from 'src/components/Wishlist/WishlistHeaderMenuItem';
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';

const ReactHamburger = dynamic(() => import('@/components/Common/ReactHamburger'));
const DesktopWhatsAppComp = dynamic(
  () => import('@/components/Common/WhatsAppIconComp/desktopIcon')
);
const MobileWhatsAppComp = dynamic(
  () => import('@/components/Common/WhatsAppIconComp/mobileIcon')
);
const LogoutModal = dynamic(() => import('@/components/LogoutModal'));
const MegaMenuDesktopView = dynamic(
  () => import('@/components/MegaMenu/MegaMenuDesktopView').then((mod) => mod.default),
  {
    ssr: false,
  }
);
const MegaMenuMobileView = dynamic(
  () => import('@/components/MegaMenu/MegaMenuMobileView').then((mod) => mod.default),
  {
    ssr: false,
  }
);

const Header = (props) => {
  const { primaryColor = '#000000', secondaryColor = '#ffffff' } = props;
  const ref = useRef();
  const dispatch = useDispatch();
  const router = useRouter();
  const [height, setHeight] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const headerRef = useRef(null);
  const [openCategory, setOpenCategory] = useState(false);
  const [openMore, setOpenMore] = useState(false);
  const [shopCategory, setShopCategory] = useState([]);
  const [isHeaderRef, setHeaderRef] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [showDesktopDropdown, setShowDesktopDropdown] = useState(false);
  const {
    user,
    items,
    catalog: { categories, productTags },
  } = useSelector((state) => ({
    user: state.userReducer,
    items: state.cartReducer.items,
    catalog: state.catalogReducer,
  }));
  const storeData = useSSRSelector((state) => state.storeReducer.store);

  const { store_info, theme, services } = storeData;
  const storeLogo = getActualOrDsStoreLogo(storeData);

  const isMobile = isMobileDevice();

  const themeColor = theme?.colors?.primary_color;
  const ordersDropdownList = getOrdersDropdownList();
  useSaveHeaderHeight(headerRef);
  const { visitorLoginFeatureStatus } = useFeatureLocks();
  const isVisitorLoginVisible = visitorLoginFeatureStatus?.isVisible;

  useEffect(() => {
    setOpen(false);
    setShowLogoutConfirmation(false);
  }, [user?.isLogin]);

  useEffect(() => {
    if (!isHeaderRef && headerRef.current) {
      setHeight(headerRef.current.offsetHeight);
      setHeaderRef(true);
    }
    if (categories && categories.length > 0) {
      const categoryTemp = categories.filter((el) => el.id !== 0);
      setShopCategory([...productTags, ...categoryTemp]);
    }
  }, [headerRef, categories]);

  function clickExpandable() {
    setOpenCategory(!openCategory);
  }

  const handleScroll = () => {
    if (headerRef.current) {
      setScrolled(headerRef.current.getBoundingClientRect().top <= 1);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', () => handleScroll(), { passive: true });

    return () => {
      window.removeEventListener('scroll', () => handleScroll(), {
        passive: true,
      });
    };
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const toggleAuthModal = () => {
    if (
      commonToggleAuthModal({
        userLogin: user?.isLogin,
        storeInfoDomain: store_info?.domain,
      })
    )
      toggleLogoutModal();
  };

  function toggleLogoutModal() {
    setShowLogoutConfirmation(!showLogoutConfirmation);
  }

  function toggleShowDesktopDropdown() {
    setShowDesktopDropdown(!showDesktopDropdown);
  }

  function onHandleOrdersClick(href) {
    if (user?.isLogin && href === PATH.ORDERS && deviceWidth > 766) {
      toggleShowDesktopDropdown();
    } else {
      router.push(getRoute(PATH.ORDERS, store_info?.domain));
    }
  }
  function toggleShowDesktopDropdown() {
    setShowDesktopDropdown(!showDesktopDropdown);
  }
  const onHandleOrdersDropdown = (item, e = null) => {
    switch (item.action) {
      case ORDERS_DROPDOWN_LIST.MY_ORDERS: {
        toggleShowDesktopDropdown();
        router.push(getRoute(PATH.ORDERS, store_info?.domain));
        break;
      }
      case ORDERS_DROPDOWN_LIST.LOGOUT: {
        toggleLogoutModal();
        break;
      }
      case ORDERS_DROPDOWN_LIST.DEFAULT_PHONE: {
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleCartClick = () => {
    if (getStoreType({ services }) === STORE_CUSTOMIZATION.B2B) {
      dispatch(toggleRfqFormModal());
      return;
    }
    router.push(getRoute(PATH.CART, store_info?.domain));
  };

  const handleClickOutside = (e) => {
    const callback = () => setShowDesktopDropdown(false);
    commonOutsideClick({ event: e, pathNo: 0, ref, callback });
  };

  function renderUserIconDesktop() {
    return (
      <>
        {deviceWidth > 766 && (
          <>
            <div className="header-1 pointer">
              <div className="mt1" onClick={() => onHandleOrdersClick(PATH.ORDERS)}>
                <UserIconDark color="#000000" width="24" height="24" />
              </div>
            </div>
            {user?.isLogin && (
              <div
                className={
                  'header-1-arrow-img ml1 pointer ' +
                  (showDesktopDropdown ? '' : 'rotate-180')
                }
                onClick={toggleShowDesktopDropdown}
              >
                <HeaderArrow color="#000000" width="10" height="10" />
              </div>
            )}
            <div
              ref={ref}
              className={
                'br2 absolute shadow-2 z-5 header-1-orderdropdown-container' +
                (isVisitorLoginVisible ? '' : '-nologin')
              }
            >
              {showDesktopDropdown &&
                ordersDropdownList.map((item) => {
                  return (
                    <>
                      {item.id === 1 && (
                        <div className="header-1-orderdropdown-container-arrow"></div>
                      )}
                      <div
                        key={item.id}
                        className={
                          'header-1-orderdropdown-container-item flex items-center z-5 ' +
                          (item.id === 3 ? 'red ' : 'black ') +
                          (item.id !== 1 && 'pointer')
                        }
                        onClick={(e) => onHandleOrdersDropdown(item, e)}
                      >
                        {item.id === 1 && (
                          <div className="mr3 mt1">
                            <UserIconDark color={'black'} width="33" height="33" />
                          </div>
                        )}
                        {item.name}
                      </div>
                    </>
                  );
                })}
            </div>
          </>
        )}
        {showLogoutConfirmation && (
          <LogoutModal
            toggleLogoutModal={toggleLogoutModal}
            executeLogout={executeLogout}
            showLogoutConfirmation={showLogoutConfirmation}
          />
        )}
      </>
    );
  }

  function renderUserIconMobile() {
    return (
      <>
        <div
          className={
            'header-1-mobile-login-navigation-container ' + (user?.isLogin ? 'red' : null)
          }
          onClick={toggleAuthModal}
        >
          <UserIconDark color="#000000" width="22" height="22" />
          <div className="mobile-translate-logout-text">
            <span>{user?.isLogin ? 'Logout' : 'Login'}</span>
          </div>
        </div>
        {showLogoutConfirmation && (
          <LogoutModal
            toggleLogoutModal={toggleLogoutModal}
            executeLogout={executeLogout}
            showLogoutConfirmation={showLogoutConfirmation}
          />
        )}
      </>
    );
  }

  /**
   * Render cartIcon
   * @return {JSX}
   */
  const _renderCartIcon = () => {
    return items.length > 0 ? (
      <div
        className="pl2 pb2 pt3 pr3 br3"
        style={{
          backgroundColor: themeColor,
        }}
      >
        <ShopingIconWrap>
          <SupermarketIcon color={secondaryColor} width="20" height="18" />
          {items && items.length > 0 && (
            <CartTotalContainer backgroundColor={secondaryColor} fontColor={themeColor}>
              {items.length}
            </CartTotalContainer>
          )}
        </ShopingIconWrap>
      </div>
    ) : (
      <article className="pl2 pb2 pt2 pr3">
        <ShopingIconWrap>
          <SupermarketIcon color={themeColor} width="20" height="18" />
        </ShopingIconWrap>
      </article>
    );
  };

  return theme ? (
    <HeaderComponent
      position={props.position}
      primaryColor={secondaryColor}
      secondaryColor={themeColor}
      ref={headerRef}
      scrolled={scrolled}
    >
      <HeaderInner>
        <HeaderSections
          style={{
            flex: '1 1 100%',
          }}
        >
          <MobileHeader
            style={{
              flex: '1 1 100%',
              paddingRight: 20,
              paddingLeft: 10,
            }}
          >
            <div>
              <ReactHamburger open={isOpen} setOpen={setOpen} theme={themeColor} />
            </div>
            <StoreName
              style={{
                paddingLeft: 10,
              }}
              showStoreNameOnMobile={props.showStoreNameOnMobile}
              fontColor={themeColor}
              onClick={() => {
                router.push(getRoute(PATH.PRODUCT, store_info?.domain));
              }}
            >
              {store_info?.name}
            </StoreName>
          </MobileHeader>
          <DesktopHeader
            style={{
              flex: '1 1 100%',
              paddingRight: 20,
              maxWidth: '45vw',
            }}
          >
            {storeLogo && getVisibilityForHeader(theme?.store_logo_status) && (
              <img
                className="header-logo-image mr3 pointer"
                src={storeLogo}
                alt="store logo"
                onClick={() => {
                  redirectToHomePage(PATH.PRODUCT, store_info?.domain);
                  setOpenCategory(false);
                }}
              />
            )}
            {getVisibilityForHeader(theme?.store_name_status) && (
              <StoreName
                onClick={() => {
                  redirectToHomePage(PATH.PRODUCT, store_info?.domain);
                  setOpenCategory(false);
                }}
                fontColor={themeColor}
              >
                {store_info?.name}
              </StoreName>
            )}
          </DesktopHeader>
        </HeaderSections>
        <HeaderSections>
          <DesktopHeader>
            <MenuItem
              onClick={() => {
                router.push(getRoute(PATH.PRODUCT, store_info?.domain));
                setOpenCategory(false);
              }}
            >
              Home
            </MenuItem>
            {theme?.cta_config?.header_cta ? (
              <MenuItem
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
                onClick={clickExpandable}
              >
                {theme?.cta_config?.header_cta}
                <HeaderIcon display="flex" size={12} iconPointer={openCategory}>
                  <Arrow color={themeColor} />
                </HeaderIcon>
                {/* Desktop Dropdown */}
                {!showMegaMenu() && openCategory && (
                  <DesktopHeaderDropdown
                    primaryColor={secondaryColor}
                    secondaryColor={themeColor}
                  >
                    <DesktopDropdownItemList>
                      {shopCategory.map((cat) => (
                        <DesktopDropdownItem
                          key={`${cat?.name}-${cat?.id}`}
                          onClick={() => {
                            setOpenCategory(false);
                            if (isPLPRequiredSystem(theme?.theme_class)) {
                              window.location.href = getRoute(
                                `${PATH.SHOP}?cid=${cat.id}`,
                                storeData?.store_info?.domain
                              );
                            } else {
                              router.push(
                                getRoute(
                                  `${PATH.PRODUCT}?cid=${cat.id}`,
                                  store_info?.domain
                                ),
                                undefined,
                                { shallow: true }
                              );
                            }
                          }}
                        >
                          {removeEmoticons(cat?.name)}
                        </DesktopDropdownItem>
                      ))}
                    </DesktopDropdownItemList>
                  </DesktopHeaderDropdown>
                )}
                {/* End Desktop Dropdown */}
              </MenuItem>
            ) : null}{' '}
            <MenuItem
              onClick={() => {
                router.push(getRoute(PATH.ABOUT_US, store_info?.domain));
              }}
            >
              About Us
            </MenuItem>
            <DesktopWhatsAppComp />
          </DesktopHeader>
          <MenuItem
            margin="0 0 0 25px"
            onClick={() => {
              router.push(getRoute(PATH.SEARCH, store_info?.domain));
            }}
          >
            <SearchIcon
              color={themeColor}
              size="18"
              className={`${props?.hideCart ? '!tw-mr-2.5' : ''}`}
            />
          </MenuItem>
          <MenuItem>
            <WishlistHeaderMenuItem
              color={themeColor}
              showComponent={isMobile ? 'icon' : 'both'}
              onClick={() => router.push(getRoute(PATH.WISHLIST, store_info?.domain))}
            />
          </MenuItem>
          {!props?.hideCart && services?.store_flag !== 0 && (
            <MenuItem margin="0 10px 0 15px" onClick={handleCartClick}>
              {_renderCartIcon()}
            </MenuItem>
          )}
          {deviceWidth > 766 && renderUserIconDesktop()}
        </HeaderSections>
      </HeaderInner>
      {showMegaMenu() && deviceWidth > 766 && (
        <MegaMenuDesktopView open={openCategory} onClose={() => setOpenCategory(false)} />
      )}
      {/* Mobile Desktop Dropdown */}
      <MobileHeader>
        {isOpen && (
          <MobileDropownContainer>
            <MobileHeaderDrawer
              // ref={headerDropdownRef}
              paddingTop={height}
              isOpen={isOpen}
              primaryColor={secondaryColor}
              secondaryColor="#000000"
            >
              <HeaderDrawerInner heightLimiter={height}>
                <HeaderSection border={true}>
                  <MenuItem
                    margin="0px"
                    onClick={() => {
                      setOpen(false);
                      router.push(getRoute(PATH.PRODUCT, store_info?.domain));
                    }}
                  >
                    <span style={{ marginRight: 24, marginLeft: 2 }}>
                      <HeaderHome color={primaryColor} />
                    </span>
                    Home
                  </MenuItem>
                </HeaderSection>
                {theme?.cta_config?.header_cta ? (
                  <HeaderExpandable heightLimiter={height}>
                    <HeaderSection
                      display="flex"
                      border={false}
                      alignItems="center"
                      justifyContent="space-between"
                      onClick={clickExpandable}
                    >
                      <MenuItem margin="0px">
                        {theme?.cta_config?.header_cta === 'Shop' && (
                          <span style={{ marginRight: 24 }}>
                            <SupermarketIcon
                              color={primaryColor}
                              width={20}
                              height={18}
                            />
                          </span>
                        )}
                        {theme?.cta_config?.header_cta}
                      </MenuItem>
                      <HeaderIcon size={16} iconPointer={openCategory}>
                        <Arrow color="#000000" />
                      </HeaderIcon>
                    </HeaderSection>
                    {showMegaMenu() ? (
                      <div style={{ paddingLeft: '50px' }}>
                        <MegaMenuMobileView
                          open={openCategory}
                          onClose={() => setOpen(false)}
                        />
                      </div>
                    ) : (
                      openCategory && (
                        <HeaderExpandedList>
                          {shopCategory.map((item) => (
                            <HeaderExpandedListItem
                              key={`${item.name}-${item.id}`}
                              onClick={() => {
                                setOpen(false);
                                if (isPLPRequiredSystem(theme?.theme_class)) {
                                  window.location.href = getRoute(
                                    `${PATH.SHOP}?cid=${item.id}`,
                                    store_info?.domain
                                  );
                                } else {
                                  router.push(
                                    getRoute(
                                      `${PATH.PRODUCT}?cid=${item.id}`,
                                      store_info?.domain
                                    ),
                                    undefined,
                                    { shallow: true }
                                  );
                                }
                              }}
                            >
                              {removeEmoticons(item.name)}
                            </HeaderExpandedListItem>
                          ))}
                        </HeaderExpandedList>
                      )
                    )}
                  </HeaderExpandable>
                ) : null}
                <HeaderSection border={true}>
                  <HeaderSectionList>
                    <HeaderSectionListItem>
                      <WishlistHeaderMenuItem
                        color={themeColor}
                        iconPosition="left"
                        wrapperClassName="!tw-gap-[23px]"
                        customTextClassName="!tw-text-[15px]"
                        onClick={() =>
                          router.push(getRoute(PATH.WISHLIST, store_info?.domain))
                        }
                      />
                    </HeaderSectionListItem>
                    <HeaderSectionListItem>
                      <OrderIcon secondaryColor="#000000" />
                      <MenuItem
                        secondaryColor="#000000"
                        onClick={() => {
                          router.push(getRoute(PATH.ORDERS, store_info?.domain));
                        }}
                      >
                        {getCustomCtaText('my_orders_cta')}
                      </MenuItem>
                    </HeaderSectionListItem>
                    <MobileWhatsAppComp secondaryColor="#000000" />
                    <HeaderSectionListItem>
                      <InfoIcon size={24} secondaryColor="#000000" />
                      <MenuItem
                        secondaryColor="#000000"
                        onClick={() => {
                          router.push(getRoute(PATH.ABOUT_US, store_info?.domain));
                        }}
                      >
                        About Us
                      </MenuItem>
                    </HeaderSectionListItem>
                  </HeaderSectionList>
                </HeaderSection>
                {showMyAccount() ? (
                  <HeaderExpandable>
                    <HeaderSection
                      display="flex"
                      border={false}
                      alignItems="center"
                      justifyContent="space-between"
                      onClick={() => setOpenMore(!openMore)}
                    >
                      <MenuItem margin="0px">More</MenuItem>
                      <HeaderIcon size={16} iconPointer={openMore}>
                        <Arrow color="#000000" />
                      </HeaderIcon>
                    </HeaderSection>
                    {openMore && (
                      <HeaderExpandedList>
                        <HeaderExpandedListItem
                          onClick={() =>
                            router.push(getRoute(PATH.MY_ACCOUNT, store_info?.domain))
                          }
                        >
                          My Account
                        </HeaderExpandedListItem>
                      </HeaderExpandedList>
                    )}
                  </HeaderExpandable>
                ) : (
                  <HeaderSection>
                    <HeaderSectionList>
                      {deviceWidth < 767 &&
                        isVisitorLoginVisible &&
                        renderUserIconMobile()}
                    </HeaderSectionList>
                  </HeaderSection>
                )}
              </HeaderDrawerInner>
            </MobileHeaderDrawer>
          </MobileDropownContainer>
        )}
      </MobileHeader>
      {/* End Mobile Desktop Dropdown */}
    </HeaderComponent>
  ) : (
    <></>
  );
};

export default Header;
